<template>
  <div>
    <card title="Affiliates Companies" :subtitle="''">
      <div>
        <Affiliate-Companies-Table/>
      </div>
    </card>
  </div>
</template>

<script>
export default {
  name: 'Affiliate-Companies-Card'
}
</script>

<style>

</style>